export const manual = `
  manual: globalSet(handle: "manual", site: $site) {
    ... on GlobalSet_Manual {
      __typename
      manual {
        ...Asset
      }
    }
  }
`
